import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function BannerContent({ rtl }) {
  const className = rtl
    ? "mobileapp_gcc p-100 rtl-style"
    : "mobileapp_gcc p-100";
  return (
    <div className={className}>
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-lg-1"
          >
            <div className="banenr_content">
              <h2>شركة اندرويد في السعودية</h2>
              <p>
                حققت شركة TekRevol، إحدى شركات أندرويد البارزة في المملكة
                العربية السعودية، خطوات كبيرة في قطاع تطوير تطبيقات الهاتف
                المحمول. بفضل نهجها المبتكر وتفانيها في الجودة، تواصل TekRevol
                قيادة السوق، حيث تقدم حلولًا متطورة مصممة خصيصًا لتلبية احتياجات
                المستخدمين في جميع أنحاء المنطقة. ومن خلال الشراكات الاستراتيجية
                والتركيز على العملاء، تعزز شركة ريفول مكانتها كلاعب رئيسي في
                صناعة التكنولوجيا في المملكة العربية السعودية.
              </p>
              <p>
                وباعتبارها شركة أندرويد رائدة يقع مقرها الرئيسي في المملكة
                العربية السعودية، تجسد TekRevol التميز في تطوير تطبيقات الهاتف
                المحمول. إن التزامها بتقديم منتجات رفيعة المستوى يلقى صدى لدى
                العملاء والمستخدمين على حدٍ سواء، مما يعزز الثقة والولاء داخل
                السوق. لا يمكن إنكار مساهمات ريفول في تطوير التكنولوجيا في
                المملكة العربية السعودية، حيث أنها تشكل مشهد تطوير تطبيقات
                الهاتف المحمول وتدفع الابتكار إلى الأمام.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                هيا بنا نبدأ
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <StaticImage
              src="../../../images/locationgcc/sa/expert.webp"
              alt="mobile app development company in dubai"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={900}
              height={750}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default BannerContent;
